export const getUserAssistanceIPQuery = () =>
    `query getNpocoEdgeIp {
        npocoEdgeIp {
            ip
        }
    }`;
